export const ugovor_o_ostavi= {
    templateId: 204,
    category: 13,
    templateTitle: "Ugovor o ostavi",
    templateDescription: `<p>.</p>`,
    description: `

  `,

    sides: [
        {
            signature: 'Ostavodavac:',
            inputs: [{
                type: 'input',
                required: true,
                placeholder: 'Posl. subjekt / Ime i prezime',        
            },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Ulica i kućni broj',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Mjesto',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'OIB',
                },
                {
                    type: "input",
                    placeholder: "Zastupa (za pr. osobe)",
                    inSignature: true,
                  },
                  {
                    type: "input",
                    placeholder: "Funkcija (za pr. osobe)",
                    inSignature: true,
                }],
            suffix: ' (u daljnjem tekstu: Ostavodavac)',
            delimiter: `i`
        },
        {
            signature: 'Ostavoprimac:',
            inputs: [{
                type: 'input',
                required: true,
                placeholder: 'Posl. subjekt / Ime i prezime',        
            },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Ulica i kućni broj',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Mjesto',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'OIB',
                },
                {
                    type: "input",
                    placeholder: "Zastupa (za pr. osobe)",
                    inSignature: true,
                  },
                  {
                    type: "input",
                    placeholder: "Funkcija (za pr. osobe)",
                    inSignature: true,
                }
            ],
            suffix: ' (u daljnjem tekstu: Ostavoprimac),'
        }
    ],
 
    
    headline: 'zaključuju sljedeći',
    title: 'UGOVOR O USKLADIŠTENJU',
    noArticleNumbers: false,

    articles: [
       
    ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/204_ugovor_o_ostavi.ts